import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Directive({
  selector: '[appAccessControl]'
})
export class AccessControlDirective implements OnInit {
  @Input() accessRole!: string;

  constructor(private elementRef: ElementRef, private auth: AuthenticationService) { }

  ngOnInit() {
    this.checkAccess();
  }

  checkAccess() {
    const accessControls: string = this.auth.currentUserValue.role;
    if (accessControls !== this.accessRole) {
      this.elementRef.nativeElement.remove();
    }
  }
}
